class TranslateService {
  constructor() {
    this.translate = {};
  }

  async getTranslates() {
    const localizationRequest = await fetch(
      "/static/locales/localization.json"
    );
    const locale = await localizationRequest.json();

    return locale;
  }
}

export const translateService = new TranslateService();



// WEBPACK FOOTER //
// ./src/services/translateService.js